import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledLoadingMaskContent } from './LoadingMaskContent.styles';

/**
 * @since 8.1.0
 */
export var LoadingMaskContent = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledLoadingMaskContent, _extends({
    ref: forwardedRef
  }, props));
});
LoadingMaskContent.displayName = 'LoadingMaskContent';